import { Path } from 'paper';
import Shape from './Shape';

export class ImportedShape extends Shape {
    constructor() {
        super('imported', ['select', 'delete']);
    }

    async init(item) {
        if (!item.pathData) console.error("Imported shape with no pathData !!", item);

        this.pathData = item.pathData;
        this.pathId = item.id;
        this.color = item.strokeColor ? item.strokeColor.toCSS(true) : '';
        switch (this.color) {
            case '#333333':
                this.family = 'cut';
                break;
            case '#008100':
                this.family = 'bend';
                break;
            default:
                this.family = 'cut';
        }
    }

    async updatePath() {
        let path = new Path(this.pathData);
        this.linkTo(path);
        return path;
    }
}
